import {CrudService} from '../services/';

export const fetchStatistics = (city_id) => {

    return CrudService._get({
        url: `statistics/index/${city_id}`
    });
};
